module.exports = __webpack_public_path__ + "img/shape-2-mobile@2x.5ddb72a3.png";